import React from 'react';
import './Header.css';

export function Header(props) {
    return (
    <div>
        <div className="header-container">
            <div className="container">
                <div className="flex flex-row">
                   <div className="content-left w-100 lg:w-40">
                        <div className="header-logoImage-container">
                            <img className="header-logoImage" src="/images/sru_bluearrowwhitetype_211207.png" alt="SRU Fleet" width="220"/>
                        </div>

                        <h1 className="text-center lg:text-left">
                            <span className='amwins-blue'>Fleet</span> Solutions
                        </h1>

                        <div className="header-text-container">
                            <p className="text-center lg:text-left">
                                Since 2008, Amwins Specialy Risk Underwriters has dedicated its practice to providing quality underwriting programs exclusively for Amwins brokers.  Its newly added transportation program delivers primary auto solutions for established fleets with a proven safety record and a willingness to adopt technology.<br/><br/>
                                <br/><br/><br/><br/>
                            </p>
                        </div>
                   </div>

                    <div className="content-right w-100 lg:w-60">
                        <div className="header-image-container">
                            <img className="header-image" src="/images/GettyImages-104314618.jpg" alt="Line of Trucks" />
                        </div>
                    </div>
                 </div>

                <div className="page-header-diagonal"></div>
            </div>
        </div>
        {props.children}
    </div>
    );
};